import { Component, OnDestroy, OnInit } from '@angular/core';
import { PlannerService } from './providers/planner.service';
import { Subscription } from 'rxjs';
import { UserSessionService } from '../services/user-session.service';
import { SidebarService } from '../services/sidebar.service';
import { PlannerFullPageService } from '../services/plannerFullPage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { of } from 'rxjs'; // ADD
import { delay } from 'rxjs/operators'; // ADD
import { FinanceService } from '../services/finance.service';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';

type MonthlyMetrics = { mlcTotale: number; mlcPrevisto: number }; // ADD


@Component({
  selector: 'app-planner',
  templateUrl: './planner.component.html',
  styleUrls: ['./planner.component.scss'],
})
export class PlannerComponent implements OnInit, OnDestroy {
  private sub: Subscription;
  private subRoute: Subscription;
  selectedVenue: any = false;
  planningFullPage = false;
  plannerType: string = this.route.snapshot.url[0]
    ? this.route.snapshot.url[0].path
    : 'core';

  // ADD
  currentMonth: Date = this.firstDayOfMonth(new Date());
  mlcTotale = 0;
  mlcPrevisto = 0;
  mlcTotalePerc = 0;
  mlcPrevistoPerc = 0;
  isLoadingMetrics = false;

  private companyId: string | number | null = null;


  public get dataFetched(): boolean {
    return this.ps.dataFetched;
  }

  constructor(
    private ps: PlannerService,
    private userSessionService: UserSessionService,
    private sidebarService: SidebarService,
    private plannerFullPageService: PlannerFullPageService,
    private route: ActivatedRoute,
    private router: Router,
    private financeService: FinanceService
  ) { }

  ngOnInit(): void {
    let currentCompany = this.getCompany();
    //console.log(currentCompany)
    this.setPageVisibility(currentCompany);
    // ADD
    this.companyId = currentCompany !== 0 ? currentCompany : null;
    this.loadMetrics();


    this.sub = this.userSessionService.$changeCompanyDetector.subscribe(
      (res) => {
        window.location.reload();
      }
    );

    this.subRoute = this.route.data.subscribe((v: any) => {
      if ('plannerType' in v) this.plannerType = v.plannerType;
    });
  }

  setPlanningFullPage() {
    this.planningFullPage =
      this.plannerFullPageService.getPlannerFullPageValue();
  }

  setPageVisibility(company: any) {
    this.selectedVenue = company != 0 ? true : false;
  }

  getCompany() {
    const company = this.userSessionService.getState('working_company');
    if (!(company == null) && !(company.name == '*')) {
      return company.id;
    } else return 0;
  }

  ngOnDestroy(): void {
    !this.sub.closed && this.sub.unsubscribe();
    this.subRoute.unsubscribe();
  }

  setPlanningFullScreen(event: any) {
    this.planningFullPage = event;
    this.sidebarService.setCollapsed(event);
    this.plannerFullPageService.setPlannerFullPage(event);
  }
  // ADD
  prevMonth(): void {
    const y = this.currentMonth.getFullYear();
    const m = this.currentMonth.getMonth();
    this.currentMonth = new Date(y, m - 1, 1);
    this.loadMetrics();
  }

  nextMonth(): void {
    const y = this.currentMonth.getFullYear();
    const m = this.currentMonth.getMonth();
    this.currentMonth = new Date(y, m + 1, 1);
    this.loadMetrics();
  }

  // REPLACE
  // REPLACE
  private loadMetrics(): void {
    const currentUser = this.userSessionService.getState('user');
    const idSede: any = this.companyId;
    const account = currentUser?.email ?? '';

    const startDateStr = this.toIsoDate(this.firstDayOfMonth(this.currentMonth));
    const endDateStr = this.toIsoDate(this.firstDayOfNextMonth(this.currentMonth));

    this.isLoadingMetrics = true;

    forkJoin({
      prev: this.financeService.getMLCPreventivazione(account, startDateStr, endDateStr, idSede),
      cons: this.financeService.getMLCConsuntivazione(account, startDateStr, endDateStr, idSede),
    })
      .pipe(finalize(() => this.isLoadingMetrics = false))
      .subscribe(({ prev, cons }) => {
        // payload: {"esito":"OK","item":{"Table":[{"MlcPrevista":0.300000}]}}
        const previstoRaw = Number(prev?.item?.Table?.[0]?.MlcPrevista) || 0;

        // payload: {"esito":"OK","item":{"Table":[{"MLC":0.0000}]}}
        const totaleRaw = Number(cons?.item?.Table?.[0]?.MLC) || 0;

        // valori grezzi (0..1)
        this.mlcPrevisto = previstoRaw;
        this.mlcTotale = totaleRaw;

        // percentuali (0..100)
        this.mlcPrevistoPerc = previstoRaw * 100;
        this.mlcTotalePerc = totaleRaw * 100;
      });
  }



  private firstDayOfMonth(d: Date): Date {
    return new Date(d.getFullYear(), d.getMonth(), 1);
  }

  private firstDayOfNextMonth(d: Date): Date {
    return new Date(d.getFullYear(), d.getMonth() + 1, 1);
  }

  private toIsoDate(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
  // ADD
  private toPercent50to60(value: number): number {
    // normalizza a [0,1] e mappa a [50,60]
    const norm = Math.abs(value % 1000) / 1000; // 0..1
    return +(50 + norm * 10).toFixed(1);        // 50.0 .. 60.0
  }

}
